// frontend/src/components/MonthSummaryBar.js
import React, { useEffect, useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import api from "../api";

export default function MonthSummaryBar({ type, month }) {
  const [data, setData] = useState(null);

  // 数値フォーマット（undefined / null / NaN は 0 扱い）
  const formatNumber = (val) => {
    const n =
      typeof val === "number"
        ? val
        : val == null
        ? 0
        : Number(val);
    return (Number.isFinite(n) ? n : 0).toLocaleString();
  };

  useEffect(() => {
    if (!month || !type) return;

    const load = async () => {
      try {
        const res = await api.get(`/api/${type}/summary-bar`, {
          params: { month },
        });
        setData(res.data);
      } catch (e) {
        console.error("[MonthSummaryBar error]", e);
        setData(null);
      }
    };

    load();
  }, [type, month]);

  if (!data) return null;

  // prev / current / next 用：obj の全キーをそのまま表示
  const renderCol = (label, rawObj) => {
    const obj = rawObj || {};
    const entries = Object.entries(obj);

    return (
      <Box
        sx={{
          minWidth: 150,
          p: 2,
          borderRadius: 2,
          border: "1px solid #ddd",
          bgcolor: "#fafafa",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: "bold", mb: 1, fontSize: "0.9rem" }}
        >
          {label}
        </Typography>

        {entries.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            データなし
          </Typography>
        )}

        {entries.map(([k, v]) => (
          <Box
            key={k}
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
          >
            <Typography variant="body2">{k}</Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              ¥{formatNumber(v)}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  };

  const yearTotal = data.yearTotal || {};
  const yearEntries = Object.entries(yearTotal);
  const profitVal = Number(yearTotal["利益"] ?? 0);

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
        月間サマリ（{month}）
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          alignItems: "flex-start",
        }}
      >
        {renderCol("前月", data.prev)}
        {renderCol("当月", data.current)}
        {renderCol("翌月", data.next)}

        {/* 年度サマリ */}
        <Box>
          <Box
            sx={{
              minWidth: 200,
              p: 2,
              borderRadius: 2,
              border: "1px solid #ddd",
              bgcolor: "#f3f7ff",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: "bold",
                mb: 1,
                fontSize: "0.9rem",
                color: "#1e3a8a",
              }}
            >
              {data.yearLabel}
            </Typography>

            {yearEntries.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                データなし
              </Typography>
            )}

            {yearEntries.map(([k, v]) => (
              <Box
                key={k}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="body2">{k}</Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 700,
                    color:
                      k === "利益"
                        ? profitVal >= 0
                          ? "green"
                          : "red"
                        : "inherit",
                  }}
                >
                  ¥{formatNumber(v)}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}
